import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import CounselorRepository from '@/repositories/counselorRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useCounselorProfileStore = defineStore({
    id: 'counselorProfile',
    state: () => ({
        counselorId: '',
        counselorNm: '',
        counselorAcademy: '',
        counselorExperience: '',
        counselorQualification: '',
        counselorField: '',
        counselorComment: '',
        counselorPhotoImg: '',
        imgFileExt: null,
    }),
    getters: {},
    actions: {
        reset() {
            this.counselorId = '';
            this.counselorNm = '';
            this.counselorAcademy = '';
            this.counselorExperience = '';
            this.counselorQualification = '';
            this.counselorField = '';
            this.counselorComment = '';
            this.counselorPhotoImg = '';
            this.imgFileExt = null;
        },
        /**
         * カウンセラープロフィール取得API
         * @param {*} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getCounselorProfileAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const counselorRepository = new CounselorRepository();
            try {
                const response = await counselorRepository.getCounselorProfileApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.counselorNm = response.data.CounselorNm;
                this.counselorAcademy = response.data.CounselorAcademy;
                this.counselorExperience = response.data.CounselorExperience;
                this.counselorQualification = response.data.CounselorQualification;
                this.counselorField = response.data.CounselorField;
                this.counselorComment = response.data.CounselorComment;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * カウンセラープロフィール画像取得API
         * @param {*} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getCounselorProfileImageAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const counselorRepository = new CounselorRepository();

            try {
                const response = await counselorRepository.getCounselorProfileImageApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.imgFileExt = response.data.ImgFileExt;
                this.counselorPhotoImg = response.data.CounselorPhotoImg;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        storage: sessionStorage,
    },
});
